import { render, staticRenderFns } from "./port-resolution.vue?vue&type=template&id=4b3dac28&scoped=true"
import script from "./port-resolution.vue?vue&type=script&lang=js"
export * from "./port-resolution.vue?vue&type=script&lang=js"
import style0 from "./port-resolution.vue?vue&type=style&index=0&id=4b3dac28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3dac28",
  null
  
)

export default component.exports